import React from 'react';
import { t } from '../i18n';
import { useNavigate } from 'react-router-dom';

const CreateProjectButton = () => {
  const navigate = useNavigate();

  const handleCreateProject = () => {
    navigate('/create-project'); // Navigate to the CreateProjectPage
  };

  return (
    <div style={styles.container}>
      <button onClick={handleCreateProject} style={styles.button}>
        {t('projectButton')}
      </button>
    </div>
  );
};

const styles = {
  container: {
    marginTop: '20px',
    textAlign: 'center',
  },
  button: {
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: 'var(--green-eucalyptus)',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
};

export default CreateProjectButton;